"use strict";

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = __importStar(require("react"));

var ReactDOM = __importStar(require("react-dom"));

require("./Modal.css");

function BaseModal(_a) {
  var show = _a.show,
      onDismiss = _a.onDismiss,
      children = _a.children,
      _b = _a.portal,
      portal = _b === void 0 ? true : _b;
  var handleClickOutside = React.useCallback(function (event) {
    if (event.target.id === "nimbus-modal") {
      onDismiss === null || onDismiss === void 0 ? void 0 : onDismiss();
    }
  }, [onDismiss]);
  var handleKeyDown = React.useCallback(function (event) {
    if (event.keyCode === 27) {
      onDismiss === null || onDismiss === void 0 ? void 0 : onDismiss();
    }
  }, [onDismiss]);
  React.useEffect(function () {
    document.addEventListener("keydown", handleKeyDown, false);
    return function () {
      document.removeEventListener("keydown", handleKeyDown, false);
    };
  }, [handleKeyDown]);
  var container = React.useMemo(function () {
    return document.createElement("div");
  }, []);
  React.useEffect(function () {
    document.body.appendChild(container);
    return function () {
      document.body.removeChild(container);
    };
  }, [container]);
  var bodyClassName = "nimbus--modal--open";
  React.useEffect(function () {
    if (show) {
      document.body.classList.add(bodyClassName);
    } else {
      document.body.classList.remove(bodyClassName);
    }

    return function () {
      document.body.classList.remove(bodyClassName);
    };
  }, [show]);
  var element = React.createElement("div", {
    id: "nimbus-modal",
    onClick: handleClickOutside,
    className: "nimbus--modal " + (show ? "is-visible" : ""),
    role: "presentation"
  }, React.createElement("div", {
    className: "nimbus--modal-wrapper",
    role: "dialog"
  }, children));

  if (!portal) {
    return element;
  }

  return ReactDOM.createPortal(element, container);
}

exports.default = BaseModal;